export default "__VITE_ASSET__B$IFTnJr__"